import React, { useEffect, useState } from "react";

import useStyles from 'isomorphic-style-loader/useStyles'
import classes from "../style.module.scss"
import _ from "lodash"
import { useIntl } from 'react-intl'

const ProductNav = (props) => {
    useStyles(classes);
    const { reviewItem, showNav, setShowNav } = props;
    
    const { navId, changeSelectedNavId } = props;
    const intl = useIntl()
    let navData;
    if (reviewItem?.total > 0) {
        navData = [
            { id: "mainNav", label: intl.formatMessage({ id: 'items' }) },
            { id: "productReviewNav", label: intl.formatMessage({ id: 'reviews' }) },
            { id: "youLikesNav", label: intl.formatMessage({ id: 'recommend' }) }
        ];
    } else {
        navData = [
            { id: "mainNav", label: intl.formatMessage({ id: 'items' }) },
            { id: "youLikesNav", label: intl.formatMessage({ id: 'recommend' }) }
        ];
    }

    const scrollHandle = event => {
        const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
        setShowNav(() => scrollTop >= 300);
    };



    useEffect(() => {
        window.addEventListener("scroll", scrollHandle);

        return () => {
            window.removeEventListener("scroll", scrollHandle);
        }
    }, []);

    return (
        <React.Fragment>
            {
                showNav && <div className={classes.ProFixedHeaderNav}>
                    <div className={classes.ProHeaderNav}>
                        {
                            navData.map((item, index) => <div onClick={() => changeSelectedNavId(item.id)} className={item.id === navId ? classes.Active : ""} key={item.id}><span>{item.label}</span></div>)
                        }
                    </div>
                </div>
            }
        </React.Fragment>

    )
}

export default ProductNav;